import { Hero } from '@/components/Layout/Hero';

export const AboutHero = () => {
  return (
    <Hero
      bgColor='bg-blue'
      h1Content='About US'
      pContent='Welcome to AWAP INVESTORS, where your financial aspirations are our driving force. We are not just a Company, we are your trusted partner in Real Estate Investment. Our mission is to provide secure, value-driven opportunities that help individuals and businesses build wealth, generate sustainable returns, and achieve long-term financial success in real estate both as an investor or realtor. AWAP INVESTORS LTD is a global digital real estate ecosystem where both low- and high-income earners can participate in real estate investment through AWAP Project Slots and Units. Our Digital Real Estate Market enables users to buy and sell landed properties securely and conveniently from anywhere in the world.'
      page='about'
      buttonBg='bg-yellow'
    />
  );
};
